<template>
  <div class="error-main">
    <div class="error-main-content">
      <div id="error-text">
        <h1 class="text-h4">
          {{ errorTitle }}
        </h1>
        <div
          id="error-body"
          class="text-h6"
        >
          <p v-html="errorBody" />
          <i18n
            v-if="showHelpLink"
            path="error-need-help.text"
            tag="p"
          >
            <a
              id="error-help-link"
              :href="helpUrl"
              target="_blank"
            >
              {{ $t('error-need-help.link-text') }}
            </a>
          </i18n>
          <div
            v-if="errorImage"
            id="error-image"
          >
            <v-img
              :src="errorImage"
              max-width="100%"
              contain
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import defaultImage from '@/assets/images/lost-in-space.svg'

export default {
  name: 'ErrorPage',
  props: {
    errorTitle: {
      type: String,
      required: true
    },
    errorBody: {
      type: String,
      required: true
    },
    errorImage: {
      type: String,
      required: false,
      default: defaultImage
    },
    showHelpLink: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    helpUrl () {
      return process.env.VUE_APP_KNOWLEDGE_BASE_URL
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/scss/variables';
.error-main {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  margin: -12px -12px -12px -12px;
  text-align: center;
  background-color: #fff;
}
.error-main-content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
#error-text {
  color: #000;
}
#error-body {
  margin-top: map-get($spacers, 6);
}
#error-image {
  width: 80%;
  margin: map-get($spacers, 16) auto 0 auto;
  max-width: 500px;
  min-height: 300px;
  @media #{map-get($display-breakpoints, 'sm-and-up')} {
    min-height: 500px;
  }
}
</style>
